import React, { useContext, useEffect } from "react"
import { options } from "../util"
import { UserContext } from "../../../../../../context/UserContext"
import { Stack, Typography } from "@mui/material"
import { Field } from "formik"
import { FormContainer, NavButtons } from "../../../../Menu/Flow"
import employerFlowStyles from "../../styles"
import { styles } from "../../../../../../legacyComponents/componentsV2/FlowV2/Fields/util"
export default function Plan(props) {
    const { mode, exitUrl, step, formik, displayOnly, employerPlanId } = props
    const { user, refreshUserProfile, getEmployerPlan } = useContext(UserContext)
    const { errors, touched, values, setFieldValue, setTouched, setErrors } = formik
    
    const employerPlan = getEmployerPlan(employerPlanId)
    const planType = employerPlan?.type || ""
    
    let hasPreviousPlan = false
    
    const article = (planType === "ICHRA" || planType === "EBHRA") ? 'an' : 'a'
    
    async function getData() {
        try {
            await refreshUserProfile()
        } catch (error) {
            console.error(error)
        }
    }
    
    useEffect(() => {
        if (user) {
            getData()
        }
    }, [user])
    
    
    return (
        <Stack spacing="30px" height="100%">
            <FormContainer>
                <Typography variant="h2" sx={employerFlowStyles.h2}>{planType} Status</Typography>
                <Typography>Tell us about any existing {planType} plans.</Typography>
                
                <Stack spacing={2} sx={{ marginTop: "20px" }}>
                    {/* Current Plan Question */}
                    {!hasPreviousPlan && (
                        <Stack>
                            <Typography sx={{ marginBottom: "8px" }}>
                                Does your company currently have {article} {planType} with another {planType} provider?
                            </Typography>
                            <Field name="movedPlan">
                                {({ field }) => (
                                    <select
                                        {...field}
                                        onChange={(e) => {
                                            const value = e.target.value
                                            field.onChange(e)
                                            setFieldValue("movedPlan", value)
                                            if (value !== "Yes") {
                                                setFieldValue("midYearPlan", "")
                                                setTouched({})
                                            }
                                        }}
                                        disabled={displayOnly || hasPreviousPlan}
                                        style={{...styles.select(!field.value), border: `1px solid ${(errors.movedPlan && touched.movedPlan) ? "#dc2626" : "#ACBEE8"}`}}
                                        onBlur={() => {
                                            setTouched({})
                                            setErrors({})
                                        }}
                                    >
                                        <option value="">Enter No/Yes</option>
                                        <option value="No">No</option>
                                        <option value="Yes">Yes</option>
                                    </select>
                                )}
                            </Field>
                            {(errors.movedPlan && touched.movedPlan) && (
                                <div className="error-message-fields">{errors.movedPlan}</div>
                            )}
                        </Stack>
                    )}
                    
                    {/* Rolled Over Plan Message */}
                    {hasPreviousPlan && (
                        <Typography sx={{ marginTop: "10px", marginBottom: "10px" }}>
                            This is a rolled over plan, you are not able to change the status.
                        </Typography>
                    )}
                    
                    {/* Mid Year Plan Question */}
                    {Boolean(values.movedPlan === "Yes") && (
                        <Stack>
                            <Typography sx={{ marginBottom: "8px" }}>
                                Will Salusion replace your existing {planType} for the current plan year?
                            </Typography>
                            <Field name="midYearPlan">
                                {({ field }) => {
                                    // Ensure value is always a string (handle legacy object values)
                                    const fieldValue = typeof field.value === 'object' && field.value !== null
                                        ? (field.value.value === true ? "1" : field.value.value === false ? "0" : "")
                                        : String(field.value || "");
                                    
                                    return (
                                        <select
                                            {...field}
                                            value={fieldValue}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setFieldValue("midYearPlan", e.target.value);
                                            }}
                                            disabled={displayOnly || hasPreviousPlan}
                                            style={{...styles.select(!field.value), border: `1px solid ${(errors.midYearPlan && touched.midYearPlan) ? "#dc2626" : "#ACBEE8"}`}}
                                        >
                                            <option value="">Select Yes or No</option>
                                            {options.midYearPlan && Object.entries(options.midYearPlan).map(([key, option]) => (
                                                <option key={key} value={key}>
                                                    {option.display || key}
                                                </option>
                                            ))}
                                        </select>
                                    );
                                }}
                            </Field>
                            {(errors.midYearPlan && touched.midYearPlan) && (
                                <div className="error-message-fields">{errors.midYearPlan}</div>
                            )}
                        </Stack>
                    )}
                </Stack>
            </FormContainer>
            
            <NavButtons mode={mode} enableSave={true} exitUrl={exitUrl} step={step} />
        </Stack>
    )
}